import { FeatureDTO } from "./FeatureDTO";

export class MatchFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
